import {useCallback, useState} from "react";
import {getBackendErrorMessage} from "../../shared/utils/httpError";
import {registrarPagamentoManual, resendFinanceiroBoletoEmail} from "./FinanceiroService";

/*
 * As duas ações sobre uma cobrança, iguais na fatura e na tela de cobranças: registrar o pagamento feito por fora e
 * reenviar o boleto por e-mail. `aoMudar` é chamado depois do pagamento, para quem mostra a cobrança recarregar.
 */
export function useAcoesDaCobranca(aoMudar) {
    const [pagando, setPagando] = useState(null);
    const [ocupado, setOcupado] = useState(false);
    const [aviso, setAviso] = useState({error: '', success: ''});

    const registrar = useCallback(async (cobranca, corpo) => {
        try {
            await registrarPagamentoManual(cobranca.id, corpo);
            setPagando(null);
            setAviso({error: '', success: 'Pagamento registrado. A cobrança ficou paga e a assinatura sai da régua.'});
            await aoMudar?.();
            return null;
        } catch (error) {
            return getBackendErrorMessage(error, 'Não foi possível registrar o pagamento.');
        }
    }, [aoMudar]);

    const reenviar = useCallback(async (cobranca) => {
        if (!cobranca?.boleto?.id) return;
        setOcupado(true);
        try {
            await resendFinanceiroBoletoEmail(cobranca.boleto.id);
            setAviso({error: '', success: 'Boleto reenviado para o e-mail da empresa e dos administradores da assinatura.'});
        } catch (error) {
            setAviso({error: getBackendErrorMessage(error, 'Não foi possível reenviar o boleto.'), success: ''});
        } finally {
            setOcupado(false);
        }
    }, []);

    return {
        pagando,
        abrirPagamento: setPagando,
        fecharPagamento: () => setPagando(null),
        registrar,
        reenviar,
        ocupado,
        aviso,
        limparAviso: () => setAviso({error: '', success: ''}),
    };
}
